import React, { useCallback, useState } from 'react';

import { PatientDatabaseApi } from '../../../../api';
import ModalBoxes from '../../../../common/feedback/ModalBoxes/ModalBoxes';
import NotificationManager from '../../../../common/notifications/NotificationManager';
import { onRequestError } from '../../../../services/handlers';

import {
  getCurrentlySelectedPatientIds,
  resolvePushToPreScreeningResult
} from './PatientDatabasePushToPreScreeningService';
import { PushToPreScreeningDialog } from './PushToPreScreeningDialog';

export function usePushToPreScreening({ apiRef, onPushSuccess, setFailedRowIds, setRowSelectionModel }) {
  const [pushStudySites, setPushStudySites] = useState(null);

  const getSelectedPatientIds = useCallback(() => getCurrentlySelectedPatientIds(apiRef), [apiRef]);

  const handlePushToPreScreening = useCallback(
    async payload => {
      let data;

      try {
        ({ data } = await PatientDatabaseApi.pushToPreScreening(payload));
      } catch (error) {
        onRequestError(error);
        throw error;
      }

      const { failedIds, successCount, failureCount, nextSelectionModel } = resolvePushToPreScreeningResult(
        data,
        getSelectedPatientIds()
      );

      setFailedRowIds(new Set(failedIds));
      setRowSelectionModel(nextSelectionModel);

      if (successCount > 0) {
        NotificationManager.success(`${successCount} pushed successfully`);

        try {
          await onPushSuccess?.();
        } catch (error) {
          onRequestError(error);
        }
      }

      if (failureCount > 0) {
        NotificationManager.error(`${failureCount} unsuccessfully pushed`);
      }

      return data;
    },
    [getSelectedPatientIds, onPushSuccess, setFailedRowIds, setRowSelectionModel]
  );

  const onPushToPreScreening = useCallback(() => {
    const selectedPatientIds = getSelectedPatientIds();

    if (selectedPatientIds.length === 0) {
      return;
    }

    ModalBoxes.open({
      component: (
        <PushToPreScreeningDialog
          selectedPatientIds={selectedPatientIds}
          onPush={handlePushToPreScreening}
          cachedStudySites={pushStudySites}
          onStudySitesLoaded={setPushStudySites}
        />
      ),
      title: 'Push To Pre-Screening',
      size: 'w500'
    });
  }, [getSelectedPatientIds, handlePushToPreScreening, pushStudySites]);

  return {
    onPushToPreScreening
  };
}
